/**
 * Cooldown cliente entre comandos Evohome (modo zona / modo sistema).
 * Alineado con EVOHOME_CMD_MIN_SPACING_S del backend (~4s).
 * Evita ráfagas que TCC acepta en cloud pero el gateway no llega a aplicar → mails de fallo.
 */
export const EVOHOME_CMD_COOLDOWN_MS = 4000;

/** Debounce de ± setpoint (tarjeta / modal) antes de enviar a TCC. */
export const EVOHOME_SETPOINT_DEBOUNCE_MS = 2000;
